// Testimonial copy and layout from the Figma landing design
// (file jOSsIUemfUuktfFyZ038R1, node 806:365).
//
// IMPORTANT: these quotes came from the design comp, not from real permissioned
// customers. They are attributed to named individuals, which reads to a visitor
// as verified social proof. Every entry must be replaced with a real, written
// permissioned quote (or the names removed) before the "landing-testimonials"
// feature flag is enabled in production.
//
// `span` is the column count on a 12-column grid at md+, matching the design's
// 3-row layout: 3/6/3, then 4/4/4, then 6/6. `tone` picks the card background
// from TestimonialWall's palette — "deep" cards stand in for the photo cards in
// the design and render white text on saturated blue.
export const testimonials = [
  // Row 1 — 3 / 6 / 3
  {
    quote:
      "Ngwaahia gives people like me a chance to shop confidently, even online.",
    name: "Ifeanyi Umeh",
    role: "Student Buyer, Owerri",
    span: 3,
    tone: "light",
  },
  {
    quote:
      "Ngwaahia helped me move from WhatsApp selling to a real storefront. Now, more people discover my clothes daily.",
    name: "Amina Yusuf",
    role: "Fashion Vendor, Abuja",
    span: 6,
    tone: "deep",
  },
  {
    quote:
      "I've gotten more engagement and loyal customers since I joined the waitlist.",
    name: "Chinedu Okafor",
    role: "Electronics Seller, Enugu",
    span: 3,
    tone: "mid",
  },

  // Row 2 — 4 / 4 / 4
  {
    quote:
      "I sell home decor items, and before Ngwaahia, I struggled to build trust with new buyers. Now, when people see my ratings and reviews, they feel confident. I've also gained new followers who keep coming back whenever I post.",
    name: "Blessing Eze",
    role: "Home Decor Seller, Port Harcourt",
    span: 4,
    tone: "strong",
  },
  {
    quote:
      "This is the kind of marketplace I've been waiting for. It's simple, fast, and built with Nigerians in mind. Even on my old phone, the app works well. I feel like someone finally made an app for people like us.",
    name: "Adewale Akinbo",
    role: "Phone Accessories Dealer, Ibadan",
    span: 4,
    tone: "light",
  },
  {
    quote:
      "I've been looking for a way to grow beyond Instagram DMs. Ngwaahia gave me a proper storefront online. My customers now follow me directly and get updates when I post new items. It's helping me grow a loyal base faster.",
    name: "Fatima Musa",
    role: "Skincare Seller, Kano",
    span: 4,
    tone: "mid",
  },

  // Row 3 — 6 / 6
  {
    quote:
      "Even on my low-end phone, the site works smoothly. Finally, an app that feels made for Nigerians like me.",
    name: "Adeboye Michael",
    role: "Phone Accessories Dealer, Ibadan",
    span: 6,
    tone: "deep",
  },
  {
    quote:
      "Seeing seller ratings and comments gives me confidence when I shop. It feels safer than buying from random pages.",
    name: "Tolu Balogun",
    role: "Frequent Buyer, Lagos",
    span: 6,
    tone: "deepest",
  },
];
